// used in topics

import Link from "next/link";

const TagPill_3 = ({ iconName, caption, topicLevel, bgColors, href }) => {
     let level1TagOptions = `text-xs ${bgColors || 'bg-gray-200 dark:bg-slate-800'} dark:text-gray-400`
     let level2TagOptions = `text-xs ${bgColors || 'bg-gray-200 dark:bg-slate-800'} dark:text-gray-400 border-gray-300`

     return (
          //  ${topicLevel === 1 ? level1TagOptions : level2TagOptions}`
          // was inline-table
          <Link
  onClick={e => e.stopPropagation()}
  href={href || ''}
  className="flex shrink-0 items-center whitespace-nowrap rounded-full px-3 py-0.5 font-inter text-xs hover:text-teal-400 bg-slate-100 dark:bg-slate-700"
>
  {iconName ? (
    <i
      className={`devicon-${iconName}-plain colored mr-3 text-sm align-middle`}
      style={{ width: '10px' }}
    />
  ) : null}
  #{caption}
</Link>
     // <Link onClick={e=>e.stopPropagation()} href={href||''} className={`flex items-center rounded-full px-3 py-0.5 font-inter text-xs hover:text-teal-400 bg-slate-100 dark:bg-slate-700 
     //      `} >
     //      {iconName ? 
     //           <i className={`devicon-${iconName}-plain colored mr-3 text-sm align-middle`} style={{width:'10px'}}></i> 
     //           :
     //           <i className=""></i>
     //      }
     //        #{caption}
     //   </Link>
);}

export default TagPill_3